/**
 * SA Shop Subscription: Monthly/Annual toggle, switch visible table and footer by data-source.
 * Scope: queries only within section wrapper. No console.log.
 */
(function() {
  var ROOT_SEL = 'sa-shop-subscription';
  var TOGGLE_SEL = '.js-subscription-toggle';
  var TABLE_WRAP_SEL = '.sa-shop-subscription__table-wrap';
  var FOOTER_SEL = '.sa-shop-subscription__footer';
  var ACTIVE_CLASS = 'sa-shop-subscription__toggle-btn--active';

  function SaShopSubscription(rootEl) {
    this.root = rootEl;
    this.toggleBtns = rootEl ? Array.from(rootEl.querySelectorAll(TOGGLE_SEL)) : [];
    this.tableWraps = rootEl ? Array.from(rootEl.querySelectorAll(TABLE_WRAP_SEL)) : [];
    this.footers = rootEl ? Array.from(rootEl.querySelectorAll(FOOTER_SEL)) : [];
    this.handleToggleClick = this.handleToggleClick.bind(this);
  }

  SaShopSubscription.prototype.init = function() {
    var self = this;
    this.toggleBtns.forEach(function(btn) {
      btn.addEventListener('click', self.handleToggleClick);
    });
  };

  SaShopSubscription.prototype.destroy = function() {
    var self = this;
    this.toggleBtns.forEach(function(btn) {
      btn.removeEventListener('click', self.handleToggleClick);
    });
  };

  SaShopSubscription.prototype.handleToggleClick = function(e) {
    var btn = e && e.currentTarget;
    if (!btn) return;
    var source = btn.getAttribute('data-source');
    if (!source) return;
    this.switchTo(source);
  };

  SaShopSubscription.prototype.switchTo = function(source) {
    var i;
    for (i = 0; i < this.toggleBtns.length; i++) {
      var b = this.toggleBtns[i];
      if (b.getAttribute('data-source') === source) {
        b.classList.add(ACTIVE_CLASS);
        b.setAttribute('aria-selected', 'true');
      } else {
        b.classList.remove(ACTIVE_CLASS);
        b.setAttribute('aria-selected', 'false');
      }
    }
    for (i = 0; i < this.tableWraps.length; i++) {
      var wrap = this.tableWraps[i];
      if (wrap.getAttribute('data-source') === source) {
        wrap.classList.add('sa-shop-subscription__table-wrap--visible');
        wrap.setAttribute('aria-hidden', 'false');
      } else {
        wrap.classList.remove('sa-shop-subscription__table-wrap--visible');
        wrap.setAttribute('aria-hidden', 'true');
      }
    }
    for (i = 0; i < this.footers.length; i++) {
      var footer = this.footers[i];
      if (footer.getAttribute('data-source') === source) {
        footer.classList.add('sa-shop-subscription__footer--visible');
        footer.setAttribute('aria-hidden', 'false');
      } else {
        footer.classList.remove('sa-shop-subscription__footer--visible');
        footer.setAttribute('aria-hidden', 'true');
      }
    }
  };

  var instances = {};

  window.initSaShopSubscription = function(sectionId) {
    var root = document.getElementById(ROOT_SEL + '-' + sectionId);
    if (!root) return;
    if (instances[sectionId]) {
      instances[sectionId].destroy();
      delete instances[sectionId];
    }
    var inst = new SaShopSubscription(root);
    inst.init();
    instances[sectionId] = inst;
  };
})();
